import { Assets, BitmapText, Container, Graphics, Sprite } from "pixi.js";
import { IScene, Manager } from "../core/Manager";
import { Reels } from "../reels/Reels";
// import { setSpinResponseDataGlobal } from "../config/GlobalVariableConfig";
import { FreeGameScene } from "./FreeGameScene";

import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound, Sound } from "@pixi/sound";
import { Easing, Group, Tween } from "tweedle.js";
import { currentBackgorundMusicVolume, isMusicBtnOnGlobal, isSuperQuickBtnOnGlobal, RespinIndex, setBackgorundMusic, setIsGameAlreadyLoaded, willBannerAutoProceedGlobal } from "../config/GlobalVariableConfig";
import { GAME_LAYOUT_HEIGHT, GAME_LAYOUT_WIDTH, REEL_SCALE, VISIBLE_SYMBOLS_PER_REEL } from "../config/reelConfig";
import { CasinoChannelHandler, casinoEventEmitter } from "../core/CasinoChannelHandler";
import { BigWin } from "./BigWin";
// import { getSpineSymbol } from "../config/getSymbol";
import { reelSpinEmitter } from "../reels/ReelInit";
import { spinData } from '../server/getServerResposesFun';

import { Logo } from "../components/Logo";
import { LogoComponent } from "../components/LogoComponent";
import { isGameAlreadyLoaded } from "../config/GlobalVariableConfig";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { DisplayObject } from "../core/displays/DisplayObject";
import { Reels as HoldAndSpinReels } from "../reelsHoldSpin/Reels";
import { getVisibleLocalBounds, wait } from "../utils";

declare const window: any;
//const translationManager = window.hacksawCasino.Translation;

// let hand: Spine;

// let tweenLogo: Tween<Spine>;
const tweenGroup: Group = new Group();
// let hitArea;
export class GameScene extends Container implements IScene {

    // Asset bundles
    assetBundles: string[] = ["game-screen", "sound", "intro-screen", "big-win"];

    private reels: Reels | null = null;
    // private holdAndWinTrigger: Spine | null = null;
    protected sceneScale: number = 0;
    protected holdAndSpinReels: HoldAndSpinReels | null = null;

    // Containers
    protected game = new Container();
    protected reelFrame = new Container();


    protected backgroundImageCont = new Container();

    protected backgroundSpine: Spine | null = null;

    protected gameIntro: Spine | null = null;

    protected track: Sprite | null = null;


    // protected banner: Banner | null = null;
    protected bigWin: BigWin | null = null;

    protected backgroundMusic: Sound | null = null;

    protected freSpinTrigger: number = 0;
    protected freSpinTriggerBaseWin: number = 0;

    protected freeGameScene: FreeGameScene | null = null;

    protected autoTriggerTimeout: ReturnType<typeof setTimeout>;

    // protected characterCont = new Container();
    // protected character: Spine | null = null;

    // protected characterHitMask: Graphics = new Graphics();


    protected multiplierVal: number = 0;
    protected multiplierText: BitmapText | null = null;
    // protected multiplierMeter: Spine | null = null;

    // protected screenWidth: number = 0;
    // protected screenHeight: number = 0;

    // protected boundAnimateCharacter: () => void;
    protected boundShakeEffect: () => void;

    // protected boundCollectMouseMult: () => void;

    protected pointerDownHandlerBase: () => void;

    // protected bonusMeterGlowFx: Spine | null = null;


    protected lineToggleTimeout: ReturnType<typeof setTimeout>;
    protected togglePlay: boolean = false;
    protected graphics: Graphics;
    protected reelResetShakePending: boolean = false;

    constructor() {
        super();

        this.setupEventListeners();

        // this.boundAnimateCharacter = this.animateCharacter.bind(this);
        this.boundShakeEffect = this.shakeEffect.bind(this);
        // this.boundCollectMouseMult = this.collectMouseMult.bind(this);

        this.pointerDownHandlerBase = this.onPointerDown.bind(this);

        // reelSpinEmitter.off('animateCharacter', this.boundAnimateCharacter);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);

        // reelSpinEmitter.off('collectMouseMult', this.boundCollectMouseMult);

        // reelSpinEmitter.on('animateCharacter', this.boundAnimateCharacter);
        reelSpinEmitter.on('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.on('triggerFeature', this.handleFeature, this);

        // reelSpinEmitter.on('collectMouseMult', this.boundCollectMouseMult);




    }

    protected setupEventListeners(): void {
        // casinoEventEmitter.on('roundEnded', this.handleRoundEnded.bind(this));
        casinoEventEmitter.on('roundStarted', this.handleRoundStarted.bind(this));
        casinoEventEmitter.on('betChanged', this.handleBetChanged.bind(this));
    }

    override  destroy() {
        // Unbind the event listener
        // casinoEventEmitter.off('betAccepted', this.handleBetAccepted.bind(this));

        console.log("inside override  destroy")

        // reelSpinEmitter.off('animateCharacter', this.boundAnimateCharacter);
        reelSpinEmitter.off('shakeEffect', this.boundShakeEffect);
        reelSpinEmitter.off('triggerFeature', this.handleFeature, this);
        // reelSpinEmitter.off('collectMouseMult', this.boundCollectMouseMult);

        DisplayComponent.unregister(LogoComponent);

        // this.character.state.clearListeners();
        // this.character.removeAllListeners();
        // this.character.destroy(true);

        casinoEventEmitter.removeAllListeners('roundStarted');
        casinoEventEmitter.removeAllListeners('betChanged');

        // this.stopIdleCheck();

        this.reels?.destroy();
        this.reels = null;
        Assets.unload(['gameIntroSkel', 'gameIntroAtlas', 'baseBackgroundSkel', 'baseBackgroundAtlas']);
        super.destroy();

    }

    private handleFeature(): Promise<void> {
        return new Promise<void>(async (resolve) => {
            console.log("trigger holdAndSpin from handleFeature");
            await this.triggerHoldAndSpin(resolve);
        });
    }

    private async triggerHoldAndSpin(callback: () => void): Promise<void> {
        // 1. Initialize, but keep hidden
        this.holdAndSpinReels = new HoldAndSpinReels();
        this.holdAndSpinReels.position.set(this.reels.x, this.reels.y);
        this.holdAndSpinReels.pivot.set(this.reels.pivot.x, this.reels.pivot.y);
        this.holdAndSpinReels.scale.set(this.reels.scale.x, this.reels.scale.y);
        this.holdAndSpinReels.visible = false; // Hide it initially!
        this.reelFrame.addChild(this.holdAndSpinReels);

        // 2. Play impact and text over the CURRENT base game reels
        this.playHoldAndSpinImpactVfx();
        (DisplayComponent.get(LogoComponent).getInstance() as Logo).playWin();
        await this.reels.appearHoldAndWinText();

        // 3. Play the Spine wipe, and swap the reels under the cover of the animation
        await this.playHoldAndSpinTransition();

        // 4. Base game is now hidden, Bonus is visible. Start the spins!
        (DisplayComponent.get(LogoComponent).getInstance() as Logo).playIdle();
        await this.spinHoldAndSpinReel();

        // 5. Reset back to base game
        await this.playReelFrameResetTransition();

        // 6. Cleanup
        if (this.holdAndSpinReels) {
            this.reelFrame.removeChild(this.holdAndSpinReels);
            this.holdAndSpinReels.destroy();
            this.holdAndSpinReels = null;
        }
        callback();
    }

    private async spinHoldAndSpinReel() {

        let freeGameTrigger = 0;
        let winAmount = 0;
        let accumulatedsWinAmount = 0;
        // let totalFGSessionWin: number;

        if (this.reels) {
            // RespinIndex.increase();
            [freeGameTrigger, winAmount, accumulatedsWinAmount] = await this.holdAndSpinReels.startPlay("BASE");

            console.log("freeGameTrigger", freeGameTrigger);
            console.log("winAmount", winAmount);

        }

        //  return [freeGameTrigger, winAmount, accumulatedsWinAmount];

        console.log("Freegame while loop for", RespinIndex.value, freeGameTrigger, "winAmount", winAmount, "accumulatedsWinAmount", accumulatedsWinAmount);

        if (winAmount > 0) {

            const isMaxWin = (freeGameTrigger === -2) ? true : false;

            await this.bigWin.bigWinFunction(winAmount, isMaxWin);
        }
        // Manager.casinoChannelHandler.reportFeatureRoundCompleted((winAmount * 100).toFixed(0));

        const featureWinCentsNum = Math.floor(winAmount * 100);
        console.log("reportUpdateFeatureTotalWin", featureWinCentsNum);

        // Manager.casinoChannelHandler.reportUpdateFeatureTotalWin((accumulatedsWinAmount * 100).toFixed(0));
        if (spinData.isMaxwinJackpotWon) { // max win reached 
            Manager.casinoChannelHandler.reportMaxWin();

        }
        Manager.casinoChannelHandler.reportGameRoundCompleted();

        if (winAmount > 0) {
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        //if (freeGameTrigger == -1 || freeGameTrigger == -2) {
        // totalFGSessionWin = accumulatedsWinAmount;
        // }

    }

    protected shakeEffect() {

        console.log("inside shakeEffect");

        let duration = 250;
        let intensity = 20;

        const original = { x: this.x, y: this.y };
        const offset = { x: 0, y: 0 };

        const tween = new Tween(offset, tweenGroup)
            .to({ x: 0, y: 0 }, duration)
            .onUpdate(() => {
                this.x = original.x + (Math.random() - 0.5) * intensity;
                this.y = original.y + (Math.random() - 0.5) * intensity;
            })
            .onComplete(() => {
                this.x = original.x;
                this.y = original.y;
                tweenGroup.remove(tween);
            })
            .start();
    }

    private playHoldAndSpinImpactVfx(): void {
        // this.playHoldAndSpinShockwave();
        // this.playHoldAndSpinParticles();
        this.shakeEffect(); // Your existing screen shake

        // Add a heavy "Punch In" camera effect using Tweedle
        const originalScaleX = this.reelFrame.scale.x;
        const originalScaleY = this.reelFrame.scale.y;

        new Tween(this.reelFrame.scale, tweenGroup)
            .to({
                x: originalScaleX * 1.05, // 5% quick zoom in
                y: originalScaleY * 1.05
            }, 150) // Fast inward punch
            .easing(Easing.Quadratic.Out)
            .yoyo(true)
            .repeat(1) // Bounces back out
            .onComplete(() => {
                // Failsafe reset
                this.reelFrame.scale.set(originalScaleX, originalScaleY);
            })
            .start();
    }

    // private playHoldAndSpinShockwave(): void {
    //     const radius = 90;
    //     const shockwave = new Graphics()
    //         .circle(0, 0, radius)
    //         .stroke({ width: 10, color: 0xffffff, alpha: 0.9 });

    //     shockwave.position.set(1500, 1500);
    //     shockwave.scale.set(0.1);
    //     shockwave.alpha = 1;

    //     this.game.addChild(shockwave);

    //     new Tween(shockwave.scale, tweenGroup)
    //         .to({ x: 3, y: 3 }, 320)
    //         .easing(Easing.Cubic.Out)
    //         .start();

    //     new Tween(shockwave, tweenGroup)
    //         .to({ alpha: 0 }, 320)
    //         .easing(Easing.Quadratic.Out)
    //         .onComplete(() => {
    //             this.game.removeChild(shockwave);
    //             shockwave.destroy();
    //         })
    //         .start();
    // }

    // private playHoldAndSpinParticles(): void {
    //     const centerX = 1500;
    //     const centerY = 1500;
    //     const count = 18;

    //     for (let i = 0; i < count; i++) {
    //         const p = new Graphics()
    //             .circle(0, 0, 6)
    //             .fill(0xfff2aa);

    //         p.position.set(centerX, centerY);
    //         p.alpha = 1;

    //         this.game.addChild(p);

    //         const angle = Math.random() * Math.PI * 2;
    //         const distance = 160 + Math.random() * 120;
    //         const duration = 260 + Math.random() * 180;

    //         const target = {
    //             x: centerX + Math.cos(angle) * distance,
    //             y: centerY + Math.sin(angle) * distance
    //         };

    //         new Tween(p, tweenGroup)
    //             .to({ x: target.x, y: target.y, alpha: 0 }, duration)
    //             .easing(Easing.Cubic.Out)
    //             .onComplete(() => {
    //                 this.game.removeChild(p);
    //                 p.destroy();
    //             })
    //             .start();
    //     }
    // }

    private playHoldAndSpinTransition(): Promise<void> {
        return new Promise<void>((resolve) => {
            const transition = Spine.from({
                skeleton: "holdAndSpinTransitionSkel",
                atlas: "holdAndSpinTransitionAtlas"
            });

            transition.label = "holdAndSpinTransition";
            transition.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);
            this.game.addChild(transition);

            // THE FIX: Swap the reels halfway through the transition.
            // Adjust this timeout (e.g., 400ms) to match the exact frame your Spine animation covers the screen.
            setTimeout(() => {
                if (this.reels && this.holdAndSpinReels) {
                    this.reels.visible = false;
                    this.holdAndSpinReels.visible = true;
                }
            }, 400);
            sound.play('dynamite_blast');
            transition.state.setAnimation(0, "transition_blast", false).listener = {
                complete: () => {
                    transition.state.clearListeners();
                    this.game.removeChild(transition);
                    transition.destroy();
                    resolve();
                }
            };
        });
    }

    private playReelFrameResetTransition(): Promise<void> {
        return new Promise<void>((resolve) => {
            const transition = Spine.from({
                skeleton: "reelFrameResetTransitionSkel",
                atlas: "reelFrameResetTransitionAtlas"
            });

            transition.label = "reelFrameResetTransition";
            transition.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);
            this.game.addChild(transition);


            setTimeout(() => {
                if (this.reels && this.holdAndSpinReels) {
                    this.reels.visible = true; // Show normal reels
                    this.holdAndSpinReels.visible = false; // Hide bonus reels
                }
            }, 400);

            const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            sound.play('transition_sound', { volume: 1, speed: timeScale });
            transition.state.setAnimation(0, "stone_falling", false).listener = {
                complete: () => {
                    transition.state.clearListeners();
                    this.game.removeChild(transition);
                    transition.destroy();
                    this.reelResetShakePending = true;
                    resolve();
                }
            };
        });
    }
    protected async handleRoundStarted() {

        this.spinReel();

    }

    protected handleBetChanged() {
        console.log('GameScene - betChanged:');
        this.resetToggleTimeout();
        this.reels.resetWinsOnBetChange();
    }



    protected onPointerDown(): void {
        clearTimeout(this.autoTriggerTimeout);
        console.log("calling freeGameSceneChnage pointerdown");
        this.freeGameSceneChnage();

        Manager.banner.off('pointerdown', this.pointerDownHandlerBase);
    }

    public async constructorWithAssets(): Promise<void> {



        this.setupBackground();
        this.setupLogo();




        // this.setupBGSound();

        this.reels = new Reels();

        // this.background.addChild(this.reels);
        // this.reels.position.set(1090, 1048);
        // this.reels.alpha = 0;

        if (isGameAlreadyLoaded) { // meaning coming from free game;
            this.setupReelFrame(false);
            const logo = DisplayComponent.get(LogoComponent).getInstance();
            logo.visible = true;
            // when coming from free-> base then music will be chnaged in the banner disappear

            // this.setupBGSound();

        }
        else {
            this.setupReelFrame(true);
            // the following will skip the intro in the game
            // this.setupReelFrame(false);
            // this.setupBGSound();
            // CasinoChannelHandler.reportGameStarted();
            // setIsGameAlreadyLoaded(true);

        }


        // this.setupTriggerText();
        this.bigWin = new BigWin(Manager.screenwidth, Manager.screenHeight);
        this.bigWin.position.set(Manager.screenwidth / 2, Manager.screenHeight / 2);
        this.addChild(this.bigWin);




        this.resize(Manager.screenwidth, Manager.screenHeight);

    }


    // private setupTriggerText() {
    //     this.holdAndWinTrigger = Spine.from({
    //         skeleton: "holdWinTextSkel",
    //         atlas: "holdWinTextAtlas"
    //     });
    //     this.holdAndWinTrigger.label = "holdAndWinTrigger";
    //     this.holdAndWinTrigger.position.set(1550, 1370);
    //     this.holdAndWinTrigger.visible = false;
    //     this.game.addChild(this.holdAndWinTrigger);
    // }

    // private appearHoldAndWinText(): Promise<void> {
    //     return new Promise<void>((resolve) => {
    //         if (!this.holdAndWinTrigger) {
    //             resolve();
    //             return;
    //         }

    //         holdAndWinTrigger.visible = true;
    //         this.holdAndWinTrigger.state.setAnimation(0, "animation", false).listener = {
    //             complete: () => {
    //                 this.holdAndWinTrigger.state.clearListeners();
    //                 this.holdAndWinTrigger.visible = false;
    //                 resolve();
    //             }
    //         };
    //     });
    // }

    protected setupBGSound() {
        this.backgroundMusic = sound.find('base_music_loop'); // initialize with ambient sound
        setBackgorundMusic(this.backgroundMusic);

        if (this.backgroundMusic) {
            this.backgroundMusic.loop = true;
            this.backgroundMusic.volume = 0;//currentBackgorundMusicVolume;
            // console.log("this.backgroundMusic.volume", this.backgroundMusic.volume);
            this.backgroundMusic.singleInstance = true;
            // this.backgroundMusic.speed = 0.5;
            this.backgroundMusic.play();

            this.backgroundMusic.muted = !isMusicBtnOnGlobal;

            const tween = new Tween(this.backgroundMusic, tweenGroup)
                .to({ volume: currentBackgorundMusicVolume }, 2000)
                .onComplete(() => {
                    tweenGroup.remove(tween);
                })
                .start();

        }
    }

    protected callFreeGameSceneChnageAuto() {

        this.autoTriggerTimeout = setTimeout(() => {
            console.log("calling freeGameSceneChnage auto")
            clearTimeout(this.autoTriggerTimeout);
            this.freeGameSceneChnage();
        }, 10000); // 10 seconds
    }

    protected resetToggleTimeout() {
        clearTimeout(this.lineToggleTimeout);
        this.lineToggleTimeout = undefined;
        this.togglePlay = false;
    }

    protected async spinReel(): Promise<void | [number, number, number]> {

        this.updateTotalMult(0);

        // Cancel any previously scheduled lineToggle
        this.resetToggleTimeout();

        if (this.reels) {
            this.reels.animateMask([3, 4, 4, 4, 3], true, this.reelResetShakePending);
            this.reelResetShakePending = false;
            const [freeGameTrigger, winAmount] = await this.reels.startPlay("BASE");
            console.log("in GameScene freeGameTrigger winAmount RespinIndex.value", freeGameTrigger, winAmount, RespinIndex.value);
            if (freeGameTrigger > 0 && Manager.banner) {

                this.freSpinTrigger = freeGameTrigger;
                this.freSpinTriggerBaseWin = winAmount;

                await this.reels?.processWinFeatureSymbol(RespinIndex.value - 1);

                Manager.casinoChannelHandler.reportFeatureEnter();

                await Manager.banner.appearFreeGameIntroBanner(this.freSpinTrigger);

                console.log("appearFreeGameIntroBanner");

                if (willBannerAutoProceedGlobal) {
                    this.callFreeGameSceneChnageAuto();
                }

                this.freeGameScene = new FreeGameScene(this.freSpinTrigger, this.freSpinTriggerBaseWin);
                await Manager.changeScene(this.freeGameScene, false);

                //attach a listner now
                Manager.banner.on('pointerdown', this.pointerDownHandlerBase);

                // this.freeGameSceneChnage(this.freSpinTrigger, this.freSpinTriggerBaseWin)
            } else if (RespinIndex.value < spinData.respins.length && spinData.respins[RespinIndex.value].featureData?.isHoldAndSpin) {
                RespinIndex.increase();
                await this.handleFeature();
            }
            else if (winAmount === -1) {
                console.log("in Gamescene- Bet declined");
            }
            else {
                await this.bigWin?.bigWinFunction(winAmount);
                Manager.casinoChannelHandler.reportGameRoundCompleted();
                // reportGameRoundCompleted();

                this.togglePlay = true;

            }

            if (freeGameTrigger === -2) { // max win reached 
                Manager.casinoChannelHandler.reportMaxWin();
            }

            // this.reels?.setReelRunning(false);

            if (this.togglePlay && winAmount > 0) {
                this.lineToggleTimeout = setTimeout(() => {
                    // this.reels.lineToggle(0); // for toggle respin index will always be 0
                }, 2000);
            }

            console.log("gggg")

        }
    }

    protected async freeGameSceneChnage() {


        // this.backgroundMusic?.stop();
        await Manager.banner?.disappearBanner();

        this.freeGameScene?.freeSpinPlay();


        // Manager.casinoChannelHandler.reportFeatureEnter();

        // const game = new FreeGameScene(freeGameTrigger, baseGameWin);
        // await Manager.changeScene(game, false);

    }


    protected setupBackground(): void {

        //this.backgroundImageCont.addChild(Sprite.from('background'));
        // this.addChild(this.backgroundImageCont);


        // this.background.addChild(Sprite.from('baseReels'));

        this.backgroundSpine = Spine.from({
            skeleton: "baseBackgroundSkel",
            atlas: "baseBackgroundAtlas",
        });

        // this.backgroundSpine.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);
        this.addChild(this.backgroundSpine);

        this.track = Sprite.from("base_track");
        this.game.addChild(this.track);

        this.addChild(this.game);
    }

    protected setupIntro(): void {

        this.gameIntro = Spine.from({
            skeleton: "gameIntroSkel",
            atlas: "gameIntroAtlas"
        })
        this.gameIntro.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);
        this.gameIntro.label = "gameIntro";
        this.addChild(this.gameIntro);
    }




    protected setupLogo(): void {
        DisplayComponent.register(new DisplayComponentFactory(LogoComponent));
        DisplayComponent.get(LogoComponent).init();
        let inst = DisplayComponent.get(LogoComponent).getInstance();
        inst.visible = false;
        this.game.addChild(inst);

        this.setupMultiplierText();
    }

    protected setupMultiplierText() {

        // this.multiplierMeter = Spine.from({
        //     skeleton: "multiplerMeterSkel",
        //     atlas: "multiplerMeterAtlas"
        // })
        // this.multiplierMeter.label = "multiplierMeter";

        // this.logoContainer.addChild(this.multiplierMeter)


        // this.multiplierMeter.state.addListener({
        //     complete: (entry: any) => {
        //         if (["start", "collect"].includes(entry.animation.name)) {
        //             this.multiplierMeter.state.setAnimation(0, "idle", true);
        //             this.multiplierMeter.state.clearListeners();
        //         }
        //     }
        // });


        // this.multiplierMeter.state.setAnimation(0, "idle", true);

        this.multiplierVal = 0;
        this.multiplierText = new BitmapText({
            text: "",
            style: {
                fontFamily: 'dtt_coin_font',
                fontSize: 100
            }
        });

        // this.multiplierText.scale = 1;
        this.multiplierText.anchor = 0.5;
        // this.logoContainer.addChild(this.multiplierText);

        // this.multiplierMeter.addSlotObject("text_dev", this.multiplierText);
        // console.log(this.sceneScale);

    }

    // protected lastNonIdleTime: number = Date.now();
    // protected idleCheckTicker?: ReturnType<typeof setInterval>;

    // protected startIdleCheck(): void {
    //     if (this.idleCheckTicker) return; // prevent duplicate intervals

    //     const idleCheckInterval: number = 15000; // Check every 500ms
    //     let idleThreshold: number = 5000 + Math.floor(Math.random() * 10000); // 5 seconds

    //     const idleVariants = ["idle_2"];


    //     this.idleCheckTicker = setInterval(() => {
    //         const now = Date.now();
    //         const currentAnim = this.character?.state.getCurrent(0)?.animation.name;

    //         if (currentAnim === "idle_1" && (now - this.lastNonIdleTime >= idleThreshold)) {
    //             // Select a random idle variant
    //             const randomAnim = idleVariants[Math.floor(Math.random() * idleVariants.length)];
    //             this.character?.state.setAnimation(0, randomAnim, false);

    //             if (randomAnim === "idle_2") {
    //                 // sound.play('wolf_character_movinghandacross_knife', { volume: 1 });
    //             }
    //             // else if (randomAnim === "idle_3") {
    //             //     sound.play('wolf_character_animation3_licking', { volume: 1 });
    //             // }


    //             this.lastNonIdleTime = now; // reset timer after playing a variant
    //             idleThreshold = 5000 + Math.floor(Math.random() * 10000); // reset idleThreshold 10-20 sec - check after that
    //         }
    //     }, idleCheckInterval);
    // }

    // protected stopIdleCheck(): void {
    //     if (this.idleCheckTicker) {
    //         clearInterval(this.idleCheckTicker);
    //         this.idleCheckTicker = undefined;
    //     }
    // }


    // protected setupCharacter(): void {
    //     this.character = Spine.from({
    //         skeleton: "characterSkel",
    //         atlas: "characterAtlas"
    //     })
    //     this.character.label = "character";

    //     this.characterCont.addChild(this.character)
    //     // this.game.addChild(this.characterCont);





    //     const animations = this.character.skeleton.data.animations.map(anim => anim.name);
    //     console.log("Available char animations:", animations);

    //     this.character.scale = 0.5;

    //     this.character.state.data.setMix("idle_1", "idle_2", 0.25); // 0.25 seconds for mix
    //     this.character.state.data.setMix("idle_1", "win_1", 0.25); // 0.25 seconds for mix
    //     this.character.state.data.setMix("idle_2", "win_1", 0.25); // 0.25 seconds for mix
    //     this.character.state.data.setMix("idle_2", "win_2", 0.25); // 0.25 seconds for mix


    //     // // Add listener to return to "idle_1_port" after the win animation completes
    //     this.character.state.addListener({
    //         start: (entry: any) => {
    //             if (["win_1", "win_2"].includes(entry.animation.name)) {
    //                 // sound.play('wolf_character_animation4_redeyes', { volume: 1 });
    //                 if (entry.animation.name == "win_1") {
    //                     // sound.play('character_jumping_sound', { volume: 1 });
    //                 } else if (entry.animation.name == "win_2") {
    //                     // sound.play('character_guiter_playing_sound', { volume: 1 });
    //                 }
    //             }
    //             else if (["idle_2"].includes(entry.animation.name)) {
    //                 // sound.play('wolf_character_animation5_flicksknife', { volume: 1 });
    //                 // sound.play('character_licking_sound', { volume: 1 });
    //             }

    //         },
    //         complete: (entry: any) => {
    //             if (["idle_2", "win_1", "win_2"].includes(entry.animation.name)) {
    //                 this.character?.state.setAnimation(0, "idle_1", true);
    //             }

    //             // if (entry.animation.name == "win_1") {
    //             //     this.shakeEffect()
    //             // }

    //             // If animation is not idle, update the timestamp
    //             if (entry.animation.name !== "idle_1") {
    //                 this.lastNonIdleTime = Date.now();
    //             }
    //         }
    //     });




    //     this.character.eventMode = "static";
    //     this.character.on("pointerdown", this.onCharacterClick);

    //     // // Start periodic check
    //     this.startIdleCheck();


    // }

    // protected onCharacterClick = () => {


    //     // const winVariants = ["action_1_desk", "action_2_desk", "action_3_desk"];

    //     const winVariants = ["idle_2", "win_1", "win_2"];

    //     const currentAnim = this.character?.state.getCurrent(0)?.animation?.name;

    //     if (currentAnim === "idle_1") {
    //         const randomIndex = Math.floor(Math.random() * winVariants.length);
    //         const winVariant = winVariants[randomIndex];
    //         this.character?.state.setAnimation(0, winVariant, false);
    //         console.log("winVariant ", winVariant);
    //     }
    // };

    // protected animateCharacter(name: string): void {

    //     this.character?.state.setAnimation(0, `${name}`, false);

    // }


    protected async setupReelFrame(doAnimate: boolean): Promise<void> {

        // this.bonusMeterGlowFx = Spine.from({
        //     skeleton: "bonusMeterGlowSkel",
        //     atlas: "bonusMeterGlowAtlas"
        // });
        // this.bonusMeterGlowFx.label = "bonusMeterGlowFx";
        // this.bonusMeterGlowFx.state.setAnimation(0, "bonus_meter_glow", true);
        // this.bonusMeterGlowFx.position.set(-311, -291);


        //this.reelFrame.addChild(this.bonusMeterGlowFx);


        const reelBack = Sprite.from('reelBackBase');
        console.log("reelBackSpine", reelBack);
        reelBack.position.set(-632, -500);
        reelBack.visible = false;

        this.reelFrame.addChild(this.reels);
        // 1. Create the Graphics (Rectangle)
        this.graphics = new Graphics()
            .rect(0, 0, 1160, 1230)
            .fill(0xDE3249);

        this.graphics.alpha = 0.01;
        this.reels.addChild(this.graphics);

        // this.reelFrame.pivot.set(rect.width / 2, rect.height / 2);
        this.reels.pivot.set(this.graphics.width / 2, this.graphics.height / 2);
        this.reels.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);


        this.reelFrame.eventMode = "static"; // prevents the character from receiving clicks when it's behind the reels (in portrait mode)

        // this.setupLogo();

        this.game.addChild(this.reelFrame);


        // this.setupCharacter();



        this.reelFrame.alpha = 0;
        // this.characterCont.alpha = 0;
        this.backgroundImageCont.alpha = 0;
        this.backgroundSpine.alpha = 0;
        this.track.alpha = 0;

        this.setupIntro();

        // this.background.addChild(this.logo);




        this.backgroundSpine.state.setAnimation(0, "animation", true); // idle ANIMATION

        // reelBackSlidesSpine.alpha = 1;
        // reelBackSlidesSpine.state.setAnimation(0, "animation", true);

        // this.character.state.setAnimation(0, "idle_1", true);


        // doAnimate = false;

        if (doAnimate) {

            //put reel logo mult on top
            const logo = DisplayComponent.get(LogoComponent).getInstance();
            logo.visible = false;


            this.gameIntro.state.addListener({
                start: () => {

                    sound.play('Intro_transition', {
                        volume: 1,
                    });

                    const bgAlphaTime = setTimeout(() => {
                        // this.logo.alpha = 1;
                        this.reelFrame.alpha = 1;
                        // this.characterCont.alpha = 1;
                        this.backgroundImageCont.alpha = 1;
                        this.backgroundSpine.alpha = 1;
                        this.track.alpha = 1;

                        clearTimeout(bgAlphaTime);
                    }, 3000);
                },
                complete: () => {
                    this.onIntroComplete();

                }
            });
            await wait(200);
            this.gameIntro.eventMode = 'static';
            this.gameIntro.interactive = true;
            // this.gameIntro?.on("pointerup", this.onIntroComplete, this);
            this.gameIntro.state.setAnimation(0, "animation", false);

        }
        else {

            this.removeChild(this.gameIntro);
            this.gameIntro.destroy(true);
            this.gameIntro = null;


            this.reelFrame.alpha = 1;
            // this.characterCont.alpha = 1;
            this.backgroundImageCont.alpha = 1;
            this.backgroundSpine.alpha = 1;
            this.track.alpha = 1;

        }



    }

    //@ts-ignore
    protected calculateReeframePivot() {
        const visibleBounds = getVisibleLocalBounds(this.reels);
        const centerX = (visibleBounds.minX + visibleBounds.maxX) / 2;
        const centerY = (visibleBounds.minY + visibleBounds.maxY) / 2;

        this.reels.pivot.set(centerX, centerY);
        // this.reelFrame.position.set(Manager.screenwidth, Manager.screenHeight);
    }

    protected onIntroComplete() {
        this.gameIntro?.off("pointerup", this.onIntroComplete, this);
        this.reelFrame.alpha = 1;
        // this.characterCont.alpha = 1;
        const logo = DisplayComponent.get(LogoComponent).getInstance();
        logo.visible = true;
        this.backgroundImageCont.alpha = 1;
        this.backgroundSpine.alpha = 1;
        this.track.alpha = 1;
        this.gameIntro.state.clearListeners();

        this.removeChild(this.gameIntro);
        this.gameIntro.destroy(true);
        this.gameIntro = null;

        // this.logo.state.setAnimation(0, "logo_intro", false);

        this.setupBGSound();
        CasinoChannelHandler.reportGameStarted();
        setIsGameAlreadyLoaded(true);
    }


    protected updateTotalMult(multVal: number) {

        if (multVal == 0) { // meaning reset
            this.multiplierVal = 0;
            this.multiplierText.text = "";
        }
        else {
            this.multiplierVal += multVal;
            this.multiplierText.text = `${this.multiplierVal}x`;
            // sound.play('multiplier_hit_on_cheese', { volume: 1 });
            // this.multiplierMeter.state.setAnimation(0, "collect", false);
        }

    }

    // public collectMouseMult(multVal: number, multText: BitmapText): Promise<void> {
    //     return new Promise(async (resolve) => {

    //         const travelTime = isSuperQuickBtnOnGlobal ? 250 : 500;

    //         const text = new BitmapText({ text: `${multText.text}`, style: multText.style });
    //         text.anchor = 0.5;
    //         text.scale = this.sceneScale;
    //         this.addChild(text);

    //         // symbol.multText.text = "";

    //         const startPos = multText.getGlobalPosition();
    //         text.x = startPos.x;
    //         text.y = startPos.y;

    //         const targetPos = this.multiplierText.getGlobalPosition();

    //         const tween = new Tween(text, tweenGroup)
    //             .to({ x: targetPos.x, y: targetPos.y }, travelTime)
    //             .easing(Easing.Cubic.Out)
    //             .onComplete(async () => {

    //                 // this.cleanupMultTravelAnimation?.();
    //                 text.position.set(targetPos.x, targetPos.y);
    //                 tweenGroup.remove(tween);
    //                 this.removeChild(text);
    //                 text.destroy();

    //                 this.updateTotalMult(multVal);
    //                 // this.multiplierFX.state.setAnimation(0, "animation", false);

    //                 resolve();
    //             })
    //             .start();

    //     });
    // }




    public update(): void {
        tweenGroup?.update();
        this.reels?.update();
        // this.banner?.update();
        this.bigWin?.update();
    }

    public resize(screenWidth: number, screenHeight: number): void {

        // this.screenWidth = screenWidth;
        // this.screenHeight = screenHeight;

        let scale: number;

        let bgScale;
        const BG_SCALE_FACTOR = Math.max(screenWidth / GAME_LAYOUT_WIDTH, screenHeight / GAME_LAYOUT_HEIGHT);
        //this.reelFrame.x = 1500; //Manager.screenwidth / 2;
        // this.reelFrame.y = 1500; //Manager.screenHeight / 2;
        this.reels.position.set(GAME_LAYOUT_WIDTH / 2, GAME_LAYOUT_HEIGHT / 2);

        if (screenWidth > screenHeight) {
            scale = 1 * Math.min(screenWidth / 1920, screenHeight / 1080);
            this.sceneScale = scale
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.game.scale.set(scale, scale);

            const xPos = (GAME_LAYOUT_WIDTH * scale - screenWidth) / 2;
            const yPos = ((GAME_LAYOUT_HEIGHT + 0) * scale - screenHeight) / 2;

            // this.y = -200 * scale;

            this.game.x = -xPos;
            this.game.y = -yPos;


            this.reels.scale = REEL_SCALE[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)];
            (this.holdAndSpinReels) && (this.holdAndSpinReels.scale = REEL_SCALE[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)]);

            // this.character.scale = 1;
            // this.characterCont.position.set(2150, 1920);

            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (GAME_LAYOUT_WIDTH * bgScale - screenWidth) / 2;
            const bgYPos = (GAME_LAYOUT_HEIGHT * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);
            this.backgroundSpine.position.set(screenWidth / 2, screenHeight / 2);
            this.backgroundSpine.scale.set(BG_SCALE_FACTOR);

            // this.track.position.set(screenWidth / 2, screenHeight / 2);
            // this.track.scale.set(BG_SCALE_FACTOR);

            // this.holdAndWinTrigger.scale = 1;

            if (this.gameIntro) {

                this.addChild(this.gameIntro);
                this.gameIntro.scale.set(bgScale, bgScale)
                const bgXPos = screenWidth / 2;
                const bgYPos = screenHeight / 2;
                this.gameIntro.position.set(bgXPos, bgYPos);
            }

            this.track.position.set(0, 825);
            this.track.scale = 1;

            // hitArea = { x: -200, y: -500, w: 400, h: 750 };

        }
        else {
            scale = 1.0 * Math.min(screenWidth / 1080, screenHeight / 1920);
            this.sceneScale = scale
            bgScale = Math.max(scale, BG_SCALE_FACTOR);

            this.game.scale.set(scale, scale);

            const xPos = (GAME_LAYOUT_WIDTH * scale - screenWidth) / 2;
            const yPos = ((GAME_LAYOUT_HEIGHT + 0) * scale - screenHeight) / 2;

            // this.y = -300 * scale;

            this.game.x = -xPos;
            this.game.y = -yPos;

            this.reels.scale = 1;
            // this.reels.scale = REEL_SCALE[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)];
            // (this.holdAndSpinReels) && (this.holdAndSpinReels.scale = REEL_SCALE[(VISIBLE_SYMBOLS_PER_REEL[1] - 4)]);
            (this.holdAndSpinReels) && (this.holdAndSpinReels.scale = 1);

            // this.character.scale = 0.85;
            // this.characterCont.position.set(1800, 1050);

            this.backgroundImageCont.scale.set(bgScale, bgScale)
            const bgXPos = (GAME_LAYOUT_WIDTH * bgScale - screenWidth) / 2;
            const bgYPos = (GAME_LAYOUT_HEIGHT * bgScale - screenHeight) / 2;
            this.backgroundImageCont.position.set(-bgXPos, -bgYPos);
            this.backgroundSpine.position.set(screenWidth / 2, screenHeight / 2);
            this.backgroundSpine.scale.set(BG_SCALE_FACTOR);

            this.track.position.set(0, 825);
            this.track.scale = 1;

            // this.holdAndWinTrigger.scale = 0.85


            if (this.gameIntro) {
                this.addChild(this.gameIntro);
                this.gameIntro.scale.set(bgScale, bgScale)
                const bgXPos = screenWidth / 2;
                const bgYPos = screenHeight / 2;
                this.gameIntro.position.set(bgXPos, bgYPos);
            }
            // hitArea = { x: -225, y: -860, w: 455, h: 478 };


        }

        this.game.children.forEach(element => {
            if (element instanceof DisplayObject) {
                element.setPositionResize(Manager.Orientation);
            }
        });

        // this.reels?.position.set(1500, 1500);

        this.bigWin?.scale.set(scale, scale);
        this.bigWin?.position.set(screenWidth / 2, screenHeight / 2);
        this.bigWin?.resize(screenWidth, screenHeight);

        // this.banner?.resize(screenWidth, screenHeight);

    }


}
